import React, { useState } from "react";

/**
 * Team logo with graceful fallback to a colored abbreviation box.
 * Usage: <TeamLogo src={g.home_logo} abbr={g.home_team_abbr} color={team.color} size={32} />
 */
export const TeamLogo = ({ src, abbr, color = "#111111", size = 32, className = "" }) => {
  const [failed, setFailed] = useState(false);
  const px = `${size}px`;

  if (!src || failed) {
    return (
      <div
        className={`flex items-center justify-center rounded-md text-[10px] font-bold text-white ${className}`}
        style={{ width: px, height: px, backgroundColor: color, fontSize: size <= 24 ? 9 : 10 }}
      >
        {abbr}
      </div>
    );
  }

  return (
    <div
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-md bg-white border border-border/60 ${className}`}
      style={{ width: px, height: px }}
    >
      <img
        src={src}
        alt={abbr}
        onError={() => setFailed(true)}
        className="max-h-full max-w-full object-contain"
        style={{ padding: size <= 28 ? 2 : 3 }}
        draggable={false}
      />
    </div>
  );
};
